import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMapPin, FiArrowRight, FiBell } from 'react-icons/fi';
import { Card } from './ui';

const RestaurantesCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Card padding="none" className="overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-5 pt-4 pb-3">
        <div className="flex items-center gap-2">
          <FiMapPin className="text-pagali-primary text-base" />
          <h3 className="text-base font-semibold text-pagali-gray-800">
            Restaurantes perto de Si
          </h3>
        </div>
        <span className="text-xs font-medium text-pagali-primary bg-purple-50 px-2 py-0.5 rounded-full">
          Em breve
        </span>
      </div>

      {/* CTA Banner */}
      <div
        className="mx-4 mb-4 rounded-2xl overflow-hidden relative"
        style={{ background: 'linear-gradient(135deg, #FFF0E8 0%, #FFE0D0 100%)' }}
      >
        {/* Background graphic */}
        <svg className="absolute inset-0 w-full h-full" aria-hidden>
          <defs>
            <pattern id="rest-dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.4" fill="#EA580C" opacity="0.14" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#rest-dots)" />
          <circle cx="92%" cy="20%" r="55" fill="#EA580C" opacity="0.07" />
          <circle cx="85%" cy="85%" r="30" fill="#EA580C" opacity="0.06" />
        </svg>

        <div className="relative px-5 py-5">
          {/* Badge */}
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold mb-3"
            style={{ background: '#FFF5EF', color: '#9A3412' }}>
            <span>🍽️</span>
            <span>Delivery & Take-away</span>
          </div>

          {/* Headline */}
          <h4 className="font-extrabold text-[17px] leading-tight mb-1.5 text-orange-700">
            A sua próxima refeição<br />a um clique de distância
          </h4>
          <p className="text-sm text-orange-600/80 leading-snug mb-4">
            Estamos a trazer os melhores restaurantes de Cabo Verde para a sua tela. Seja o primeiro a saber!
          </p>

          {/* CTA buttons */}
          <div className="flex gap-2 flex-wrap">
            <button
              onClick={() => navigate('/restaurantes')}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold transition-all"
              style={{ background: '#EA580C', color: '#fff' }}
            >
              Explorar
              <FiArrowRight size={14} />
            </button>
            <button
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold border transition-all"
              style={{ borderColor: '#EA580C', color: '#EA580C', background: 'transparent' }}
              onClick={() => {
                // Futuramente: subscrever notificações de novos restaurantes
                alert('Será notificado quando os restaurantes estiverem disponíveis!');
              }}
            >
              <FiBell size={13} />
              Notificar-me
            </button>
          </div>
        </div>
      </div>

      {/* Placeholder tiles — simulam restaurantes futuros */}
      <div className="px-4 pb-4 grid grid-cols-3 gap-2">
        {['🍕 Pizzaria', '🍔 Burger', '🥗 Saudável'].map((label) => (
          <div
            key={label}
            className="flex flex-col items-center justify-center h-16 rounded-xl text-xs text-pagali-gray-400 font-medium gap-1"
            style={{ background: '#F9F9F9', border: '1.5px dashed #E5E7EB' }}
          >
            <span className="text-lg">{label.split(' ')[0]}</span>
            <span>{label.split(' ').slice(1).join(' ')}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default RestaurantesCard;
